// Function definitions
const search = function(params = {}) {
    return window.axios.get('/api/forms', {params: params});
};

const create = function(form) {
    return window.axios.post('/api/forms', form);
};

const get = function(id) {
    return window.axios.get('/api/forms/' + id);
};

const update = function(form) {
    return window.axios.put('/api/forms/' + form.id, form);
};

const save = function(form) {
    if (form.id) {
        return update(form);
    }
    return create(form);
};

const deleteForm = function(form) {
    return window.axios.delete('/api/forms/'+form.id);
};

const nextNo = function() {
    return window.axios.get('/api/forms/next-no');
};

const preview = function(id) {
    return window.axios.get('/api/forms/' + id + '/preview');
};

const makePDF = function(id) {
    return window.axios.post('/api/forms/' + id + '/make-pdf');
};

const loadPrevious = function (type ,site_id, exclude_id) {
    return window.axios.get('/api/forms/prev', {
        params: {
            site_id: site_id,
            type: type,
            exclude_id: exclude_id,
        },
    });
};

const updateInvoice = function(form) {
    return window.axios.post('/api/forms/'+form.id+'/invoice', form);
};

export default {
    search,
    create,
    get,
    update,
    save,
    delete: deleteForm,
    nextNo,
    preview,
    makePDF,
    loadPrevious,
    updateInvoice,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/FormService.js